<template>
  <PrintPageLandscape :page-number="pageNumber" :page-count="pageCount">
    <PresentationCover>
      <template #corner>2026</template>

      <div class="presentation-cover__logo">
        <img
          class="presentation-cover__logo-image"
          src="/img/master_presentation/master_presentation_logo.png"
          alt="eway – ONE LIFE ONE PLANET ONE WAY"
        />
      </div>

      <p class="presentation-cover__standard-text">
        {{ genderSalutation }} {{ project.customer.lastname }}, anbei ihr personalisiertes Angebot.
      </p>

      <p class="presentation-cover__eyebrow">Photovoltaik · Industrielle Stärke</p>

      <h1 class="presentation-cover__title">e way Energy GmbH</h1>

      <p class="presentation-cover__subtitle">
        Masterpräsentation — EPC, O&amp;M und Projektentwicklung für PV und BESS in Deutschland.
      </p>

      <div class="presentation-cover__accent" aria-hidden="true"></div>

      <p class="presentation-cover__caption">
        Teil der Salvia Gebäudetechnik Gruppe · Eiffage Énergie Systèmes
      </p>

      <p class="presentation-cover__standard-text">erstellt am {{ $date() }}</p>
    </PresentationCover>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationCover from '@/views/MasterPresentation/PresentationCover';
import { genderSalutation } from '@/helpers/text';
export default {
  name: 'MasterPresentationPrintPage01',

  components: {
    PrintPageLandscape,
    PresentationCover,
  },

  props: {
    project: {
      type: Object,
      default: null,
    },
    pageCount: {
      type: Number,
      default: null,
    },
    pageNumber: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    genderSalutation() {
      return genderSalutation(this.project.customer.salutation);
    },
  },
};
</script>
